/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".m-t-20[_ngcontent-%COMP%]{margin-top:20px}.m-t-40[_ngcontent-%COMP%]{margin-top:40px}.center[_ngcontent-%COMP%]{text-align:center}\n/*# sourceMappingURL=alert.component.css.map*/"];
export { styles as styles };
